<template>
  <div>
    <v-card-text>
      <v-form @submit.prevent="saveAuthorization" ref="form" :disabled="disableForm">
        <v-container style="border: solid 1px #e1e3e2; border-radius: 15px; padding: 15px">
          <v-row dense>
            <v-col class="d-flex" cols="12" sm="3">
              <v-radio-group data-cy="radio-potencial-doador" v-model="potentialDonor" @change="teste()" :rules="formRules">
                <p>
                  {{ $t('descriptions.potential_donor') }}<span style="alertColor">*</span>
                </p>

                <v-radio :label="$t('buttons.yes')" :disabled="isEditing" value="0" color="greenColor"></v-radio>

                <v-radio :label="$t('buttons.no')" value="1" color="greenColor"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col class="d-flex" cols="12" sm="4" v-if="isPotencialDonor">
              <v-autocomplete :items="notDonationItems" item-text="description" item-value="description"
                variant="outlined" :rules="formRules" color="greenColor" @change="changeReason()"
                v-model="reason_selected">
                <template v-slot:label>
                  {{ $t('descriptions.choose_a_reason') }} <span style="alertColor">*</span>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col class="d-flex flex-column" cols="12" sm="5"
              v-if="reason_selected && openSubReasonsOptions && isPotencialDonor">
              <v-autocomplete :items="subItems" item-text="description" item-value="id" variant="outlined"
                :rules="formRules" color="greenColor" v-model="resource.reason_assessment_id">
                <template v-slot:label>
                  {{
                    reason_selected == "Ausência de Familiares"
                      ? $t('descriptions.family_contact_question')
                      : `${$t('descriptions.choose_a_option')}:`
                  }}<span style="alertColor">*</span>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col class="d-flex flex-column" cols="12" sm="5" v-if="reason_selected && openJustification">
              <v-text-field color="greenColor" v-model="justification">
                <template v-slot:label> {{ $t('descriptions.justification') }}: </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row dense class="authorization-actions">
            <v-btn
            data-cy="btn-save-atualize"
              class="rounded-lg authorization-action-btn"
              elevation="0"
              color="#41916b"
              @click="saveAuthorization()"
              :loading="loading"
              v-if="!disableForm"
            >
              <span class="textBtn">
                {{ saveBTN }}
              </span>
            </v-btn>

            <v-btn
              class="authorization-edit-btn"
              color="#41916b"
              fab
              small
              dark
              @click="disableForm = false"
              v-if="disableForm && isPotencialDonor"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>

            <BackToGridBtn />
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>

    <v-dialog v-model="ending_pme_model" persistent width="600">
      <v-card>
        <EndingPme @closeDialog="ending_pme_model = false" />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import EndingPme from "@/components/pacientes/provavel-doador/ending-pme/EndingPme.vue";
import BackToGridBtn from "@/components/widgets/BackToGridBtn";
export default {
  data() {
    return {
      resource: {},
      notDonationItems: [],
      reason_selected: "",
      formRules: [(v) => !!v || this.$t('messages.required_field')],
      disableForm: false,
      subItems: [],
      loading: false,
      justification: "",
      disableForView: false,
      disableSaveButton: false,
      greenColor: "#086318",
      alertColor: "red",
      ending_pme_model: false,
      isEditing: false,
      potentialDonor: null,
    };
  },

  components: {
    EndingPme,
    BackToGridBtn
  },

  computed: {
    ...mapGetters({
      patientData: "getPatientData",
      donorId: "getDonorId",
    }),

    saveBTN() {
      return this.isEditing ? this.$t('buttons.to_update') : this.$t('buttons.save');
    },

    patientType() {
      return this.patientData.kind_of_donor_id == 1 ? "ME" : "PCR";
    },

    isPotencialDonor() {
      return this.potentialDonor == "1";
    },

    openSubReasonsOptions() {
      return [
        "Contraindicação absoluta para doação",
        "Contraindicação Absoluta",
      ].includes(this.reason_selected);
    },

    openJustification() {
      return ["OUTROS", "Logística inadequada"].includes(this.reason_selected);
    },
  },

  watch: {
    patientData: {
      handler(item) {
        this.fillForm(item);
      },

      immediate: true,
    },
  },

  async created() {
    await this.getOptionsByKindOfDonor(this.patientData.kind_of_donor_id);

    if (this.patientData) {
      this.fillForm(this.patientData);
    }
  },

  methods: {
    ...mapActions(["changeSnackBarData"]),

    fillForm(item) {
      if (item.initial_assessment) {
        this.disableForm = true;
        this.isEditing = true;
        this.potentialDonor = "0";
        this.disableSaveButton = true;

        if (item.initial_assessment.reason_assessment.id) {
          this.potentialDonor = "1";
          this.reason_selected =
            item.initial_assessment.reason_assessment.option_not_to_donate.description;
          this.resource.reason_assessment_id = parseInt(item.initial_assessment.reason_assessment_id);
          this.changeReason();
          this.justification = item.initial_assessment.justification;
          this.disableForView = true;
        }
      }
    },

    async getOptionsByKindOfDonor(kindOfDonorId) {
      const result = await axios.get(
        `/option_not_to_donates/kind_of_donor_id/${kindOfDonorId}`
      );

      this.notDonationItems = result.data ? result.data : result.data.data;
    },

    changeReason() {
      const selectedItem = this.notDonationItems.find(
        item => item.description == this.reason_selected
      );

      this.subItems = selectedItem
        ? selectedItem.reason_assessments
        : [];
    },

    buildPayload() {
      return {
        reason_assessment_id:
          this.potentialDonor == "0"
            ? null
            : this.checkReasonByDonorType(),

        justification:
          this.potentialDonor == "0"
            ? null
            : this.justification || null,

        ...(this.isEditing
          ? {}
          : {
            not_suitable_for_donor_flg:
              this.potentialDonor,
          }),
      };
    },

    saveAuthorization() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        let donor_id = this.patientData.id ? this.patientData.id : this.donorId;

        const data = this.buildPayload();

        axios({
          method: "PATCH",
          url: this.isEditing
            ? `/initial_assessments/${donor_id}`
            : `/donor/initial_assessment/${donor_id}`,
          data: data,
        })
          .then((response) => {
            this.sucessMessage = response.data.message;
            this.errorMessage = "";
            this.loading = false;
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: this.sucessMessage,
              bodyMessage: "",
              cardColor: "success",
              titleIcon: "mdi-check-circle",
            });

            setTimeout(() => {
              this.closeSnackBar();
              this.redirect(data);
            }, 2000);
          })
          .catch((err) => {
            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: this.$t('messages.something_went_wrong'),
              bodyMessage: err.details,
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });
            this.loading = false;

            setTimeout(() => {
              this.closeSnackBar();
            }, 5000);
          });
      }
    },

    checkReasonByDonorType() {
      const subItens = this.subItems;
      const subItensQuantity = subItens.length;

      if (subItensQuantity == 1) {
        //se não houver subMotivos, ele usa o próprio item selecionado como motivo
        return subItens[0].id;
      } else {
        return this.justification ? null : this.resource.reason_assessment_id;
      }
    },

    redirect(data) {
      const familyPermissionRoute = "/aceite-familiar";
      const current_path = this.$router.history.current.path;
      const isPatientFit = data.not_suitable_for_donor_flg == "0";

      let route = "/pacientes";

      if (isPatientFit) {
        if (current_path == "/validacao-doador-me") {
          this.ending_pme_model = true;
        } else {
          this.$router.push(familyPermissionRoute);
        }
      } else {
        this.$router.push(route);
      }
    },

    clearField() {
      this.reason_selected = '',
        this.$refs.form.resetValidation()
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>
<style scoped>
.authorization-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}

.authorization-action-btn,
.authorization-edit-btn {
  margin-right: 8px;
}

.authorization-action-btn:last-child {
  margin-right: 0;
}

.textBtn {
  color: #fff;
}

@media (max-width: 768px) {
  .authorization-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .authorization-action-btn,
  .authorization-edit-btn {
    width: 100%;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .authorization-edit-btn {
    border-radius: 8px !important;
  }

  .authorization-action-btn:last-child,
  .authorization-edit-btn:last-child {
    margin-bottom: 0;
  }
}
</style>